module.exports = __webpack_public_path__ + "img/slide14.bb7cb8de.png";